export default "__VITE_ASSET__56c38a6b__"